import styled from 'styled-components';

export const Table = styled.div`
  margin-top: 3rem;
`;
